/**
 * "Skip for now & set reminder" affordance shown under the primary CTA on
 * the optional wizard steps. The reminder itself isn't wired yet — for now
 * skipping just advances the flow.
 */
import { Button } from '@/lib/base/buttons/button';

interface SkipButtonProps {
  onSkip: () => void;
}

export function SkipButton({ onSkip }: SkipButtonProps) {
  return (
    <Button color='link-gray' size='sm' onClick={onSkip} className='mx-auto'>
      Skip for now &amp; set reminder
    </Button>
  );
}
